export const columns = [
    {
        prop: "companyName",
        label: "公司名称",
    },
    {
        prop: "creditCode",
        label: "统一社会信用编码",
        width: "180px",
    },
    {
        prop: "legalPersonName",
        label: "法人",
    },
    {
        prop: "establishTime",
        label: "成立日期",
        width: "160",
    },
    {
        prop: "regCapital",
        label: "注册资本",
    },
    {
        prop: "regLocation",
        label: "注册地址",
    },
    {
        prop: "industry",
        label: "行业",
    },
    {
        prop: "custTypeName",
        label: "企业类型",
    },
    {
        prop: "comBusinessStatus",
        label: "企业状态",
    },
    {
        label: "操作",
        slot: "operate",
    },
];
